module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "main-menu__submenu"
  }, [_c('li', {
    staticClass: "main-menu__item"
  }, [_c('router-link', {
    class: _vm.activeMenu,
    attrs: {
      "to": {
        name: 'Stocks'
      }
    }
  }, [_c('md-icon', [_vm._v("view_stream")]), _vm._v(" "), _c('span', [_vm._v("Склады")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06101c8a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/stock/menus/MainMenu.vue
// module id = 1028
// module chunks = 0